/**
 * @name SnackbarService
 * @description Servicio para la gestión de snackbars
 * @author Ricardo Guerra
 */

import { Subject } from 'rxjs';

const snackbarSubject = new Subject();

// Enable subscribing to snackbar observable
const getSnackbar = () => {
  return snackbarSubject.asObservable();
};

/**
 * Success Snackbar 
 * @param {string} message
 */
const success = (message) => {
  openSnackbar({ open: true, type: 'success', message });
};

/**
 * Error Snackbar 
 * @param {string} message
 */
const error = (message) => {
  openSnackbar({ open: true, type: 'error', message });
};

/**
 * Info Snackbar 
 * @param {string} message
 */
const info = (message) => {
  openSnackbar({ open: true, type: 'info', message });
};

/**
 * Warnign Snackbar 
 * @param {string} message
 */
const warn = (message) => {
  openSnackbar({ open: true, type: 'warn', message });
};

/**
 * Send Snackbar
 * @param {boolean} open
 * @param {string} message
 * @param {string} type (success, error, info, warnign) 
 */
const openSnackbar = (open, type, message) => {
  snackbarSubject.next(open, type, message);
};

export const SnackbarService = {
  getSnackbar,
  success,
  error,
  info,
  warn,
  openSnackbar,
};